export default __webpack_public_path__ + "static/realLeaf3-4894270d305a74ea7df2ca0747bc60db.png";